import { __ } from '@wordpress/i18n';
import { PanelBody,ToggleControl,RangeControl, SelectControl ,FormTokenField } from '@wordpress/components';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import {VayuBlocksDimensions, VayuBlocksTextControl, VayuBlocksToggleControl, VayuBlocksRangeControl, 
    VayuBlocksBackground, VayuBlocksAlignment,VayuBlocksTypography,VayuBlocksBorder } from '@vayu-blocks';

const Post = ({ attributes, setAttributes, openPanels, onTogglePanel}) => {
    
    const {pg_allCategories,sortByOrder,sortByField, pg_featuredImageOnly, 
        selectedCategories, showpagination, pg_numberOfCategories, pg_numberOfTags,
    } = attributes;

    const getView = VayuBlocksDevice(); 

    //Expert number of words
    const getExcerptnumberview = () => {
        switch (getView) {
            case 'Desktop':
                return attributes.pg_excerptWords;
            case 'Tablet':
                return attributes.pg_excerptWordsTablet;
            case 'Mobile':
                return attributes.pg_excerptWordsMobile;
            default:
                return undefined;
        }
    };
    
    const getExcerptnumberType = () => {
        switch (getView) {
            case 'Desktop':
                return attributes.Excerptnumber;
            case 'Tablet':
                return attributes.ExcerptnumberTablet;
            case 'Mobile':
                return attributes.ExcerptnumberMobile;
            default:
                return undefined;
        }
    };
    
    const changeExcerptnumberType = (type) => {
        if ('Desktop' === getView) {
            setAttributes({ Excerpt: type, ExcerptTablet: type, ExcerptMobile: type });
        } else if ('Tablet' === getView) {
            setAttributes({ ExcerptTablet: type });
        } else if ('Mobile' === getView) {
            setAttributes({ ExcerptMobile: type });
        }
    };
    
    const changeExcerptnumber = (value) => {
        switch (getView) {
            case 'Desktop':
                setAttributes({ pg_excerptWords: value });
                break;
            case 'Tablet':
                setAttributes({ pg_excerptWordsTablet: value});
                break;
            case 'Mobile':
                setAttributes({pg_excerptWordsMobile: value });
                break;
        }
    };

    const suggestions = pg_allCategories.length > 0 
    ? pg_allCategories.map(category => category.name)
    : [];

    const tokenIsValid = (token) => {
        return suggestions.includes(token);
    };


    return (
        <>
            <PanelBody  title={__('Layout', 'vayu-blocks')} opened={openPanels['settings-layout']}
        onToggle={() => onTogglePanel('settings-layout')} >

                <VayuBlocksRangeControl
                    max = {6}
                    min = {1}
                    label={<VayuBlocksDeviceControl label={__('Number Of Columns', 'vayu-blocks')} classname='bold'/>}
                    withInputField = {false}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    attribute={{key:'column', value:attributes.column}}
                />

                <VayuBlocksRangeControl
                    max = {6}
                    min = {1}
                    label={<VayuBlocksDeviceControl label={__('Number Of Rows', 'vayu-blocks')} classname='bold'/>}
                    withInputField = {false}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    attribute={{key:'row', value:attributes.row}}
                />


                <diV className="vb-post-gap">
                    <VayuBlocksDimensions
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        dimensions={{ padding: { key: 'horigap', value: attributes.horigap },
                        margin: { key: 'vergap', value: attributes.vergap }}}
                        sides= {{padding: ['horizontal'], margin: ['vertical']}}
                        label={{ panel:'Post Gap',padding:'Horizontal',margin:'vertical'}}
                        inputProps = {{
                            padding: { min: 0 , max:100 },
                            margin: { min: 0, max:100 }
                            }}
                    />
                </diV>

            </PanelBody>
 
            <PanelBody title={__('Controls', 'vayu-blocks')} opened={openPanels['settings-controls']}
        onToggle={() => onTogglePanel('settings-controls')}  >

                <span> {<VayuBlocksDeviceControl label={__('Controls', 'vayu-blocks')} classname='bold'/>}</span>

                <div className="vb-toggle-wrapper-post-grid">
                <VayuBlocksToggleControl
                    label={__('Show Excerpt', 'vayu-blocks')}
                    checked={{key:'expertview', value:attributes.expertview}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

                {attributes.expertview?.[getView] && (
                      <div className="vb-toggle-wrapper-post-grid">
                        <RangeControl
                            label={__('Number of words in excerpt', 'vayu-blocks')}
                            value={getExcerptnumberview()}
                            type={getExcerptnumberType()}
                            changeType={changeExcerptnumberType}
                            onChange={(value) =>changeExcerptnumber(value)}
                            min={1}
                            max={100}
                        />

                        <VayuBlocksTextControl
                            label={__('Last Word', 'vayu-blocks')}
                            value={attributes.ExcerptSelector}
                            onChange={(value) =>setAttributes({ExcerptSelector: value})}
                        />
                    </div>
                )}

                <VayuBlocksToggleControl
                    label={__('Show Full Content', 'vayu-blocks')}
                    checked={{key:'fullContent', value:attributes.fullContent}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

                <VayuBlocksToggleControl
                    label={__('Show Featured Image', 'vayu-blocks')}
                    checked={{key:'featuredImage', value:attributes.featuredImage}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

                <VayuBlocksToggleControl
                    label={__('Show Categories', 'vayu-blocks')}
                    checked={{key:'categori', value:attributes.categori}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />
                    {attributes.categori?.[getView] && (
                        <RangeControl
                            label={__('Number of Categories', 'vayu-blocks')}
                            value={pg_numberOfCategories}
                            onChange={(value) => setAttributes({pg_numberOfCategories:value})}
                            min={1}
                            max={5}
                            marks
                            withInputField={false}
                        />
                    )}

                <VayuBlocksToggleControl
                    label={__('Show Author', 'vayu-blocks')}
                    checked={{key:'auth', value:attributes.auth}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

                <VayuBlocksToggleControl
                    label={__('Show Date', 'vayu-blocks')}
                    checked={{key:'date', value:attributes.date}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

                <VayuBlocksToggleControl
                    label={__('Show Tags', 'vayu-blocks')}
                    checked={{key:'Showtag', value:attributes.Showtag}}
                    onChange={(key, value) => setAttributes({ [key]: value })}
                    responsive={true}
                />

                    {attributes.Showtag?.[getView] && (
                        <RangeControl
                            label={__('Number of Tags', 'vayu-blocks')}
                            value={pg_numberOfTags}
                            onChange={(value) => setAttributes({pg_numberOfTags:value})}
                            min={1}
                            max={5}
                            marks
                            withInputField={false}
                        />
                    )}

                </div>

                <VayuBlocksToggleControl
                    label={__('Show Pagination', 'vayu-blocks')}
                    checked={showpagination}
                    onChange={(value) => setAttributes({
                        showpagination:value
                    })}
                />
            </PanelBody>

            <PanelBody title={__('Filter', 'vayu-blocks')} opened={openPanels['settings-filter']}
        onToggle={() => onTogglePanel('settings-filter')} >
                <FormTokenField
                    __experimentalValidateInput={tokenIsValid}
                    __experimentalAutoSelectFirstMatch
                    __experimentalExpandOnFocus
                    label="By Category"
                    onChange={(value)=>setAttributes({selectedCategories:value}) }
                    suggestions={suggestions}
                    value={selectedCategories}   
                />
                <br />
                <ToggleControl
                    label={__('Featured Image Post Only', 'vayu-blocks')}
                    checked={pg_featuredImageOnly}
                    onChange={(value) => setAttributes({ pg_featuredImageOnly: value })}
                />
            <SelectControl
                label="Sort Order"
                value={sortByOrder}  // Corrected typo here
                options={[
                    { value: 'desc', label: 'Descending' },  // Corrected typo here
                    { value: 'asc', label: 'Ascending' }      // Corrected typo here
                ]}
                onChange={(value) => setAttributes({ sortByOrder: value })}  // Corrected typo here
            />
            <SelectControl
                label="Sort By Field"
                value={sortByField}
                options={[
                    { value: 'date', label: 'Date' },
                    { value: 'modified', label: 'Last Modified' },
                    { value: 'title', label: 'Title' },
                    { value: 'id', label: 'Post ID' }  // Corrected 'Id' to 'id' and 'PostId' to 'Post ID'
                ]}
                onChange={(value) => setAttributes({ sortByField: value })}
            />



            </PanelBody>

            <PanelBody title={__('Pagination', 'vayu-blocks')} opened={openPanels['settings-pagination']}
        onToggle={() => onTogglePanel('settings-pagination')} >
                <VayuBlocksToggleControl
                    label={__('Show Pagination', 'vayu-blocks')}
                    checked={showpagination}
                    onChange={(value) => setAttributes({
                        showpagination:value
                    })}
                />
                {showpagination && (
                    <>

                        <VayuBlocksAlignment
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            alignment = {{key:'pg_Paginationalignment',value:attributes.pg_Paginationalignment}}
                        />

                        <div className="vb-post-grid-typography">
                            <VayuBlocksTypography
                                value={attributes.typography}
                                onChange={(newValues) => {setAttributes({typography:newValues})}}
                            />
                        </div>

                        <div className="vb-post-grid-typography">
                            <VayuBlocksBackground
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                colorPanel = {[
                                    {
                                        active: ['gradient'],
                                        label: 'Background',
                                        key:'pg_PaginationbackgroundColor',
                                        value:attributes.pg_PaginationbackgroundColor
                                    },
                                    {
                                        active: ['color'],
                                        label: 'Text',
                                        key:'pg_PaginationColor',
                                        value:attributes.pg_PaginationColor
                                    },
                                    {
                                        active: ['color'],
                                        label: 'Active',
                                        key:'pg_PaginationactiveColor',
                                        value:attributes.pg_PaginationactiveColor
                                    }
                                ]}
                            />
                        </div>

                        <div className="vb-post-grid-typography">
                            <VayuBlocksBorder 
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                border={{key:'pg_paginationborder',value:attributes.pg_paginationborder}}
                                borderRadius={{key:'pg_paginationradius',value:attributes.pg_paginationradius}}
                            />
                        </div>
                        
                        <div className='vayu-blocks-dimension-pagination vb-post-grid-typography'>
                            <VayuBlocksDimensions  
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                dimensions = {{padding:{key:'pg_Paginationpadding',value:attributes.pg_Paginationpadding},}}
                            />
                        </div>
                
                    </>
                )}

            </PanelBody>
        </>
    );
};

export default Post;